import {
  PatientExportDTO,
  PccUpdateEmrMeasurement
} from '../../shared/model/pcc.model'

export function getVitalsFromReportingObject(
  patientExport: Partial<PatientExportDTO>
) {
  return Object.fromEntries(
    Object.entries(patientExport).filter(([key, value]) => {
      const exportKey: keyof PccUpdateEmrMeasurement =
        key as keyof PccUpdateEmrMeasurement
      return (
        exportKey === 'bodyTemperature' ||
        exportKey === 'systolicPressure' ||
        exportKey === 'diastolicPressure' ||
        exportKey === 'spo2' ||
        exportKey === 'heartRate' ||
        exportKey === 'respirationRate' ||
        exportKey === 'bloodGlucose'
      )
    })
  )
}
